<template>
    <div class="provider-signup-page" v-if="!signedUp">
        <b-form @submit="onSubmit">
            <b-container>
                <b-row align-h="center">
                    <b-col cols="3">
                        <b-form-group id="provider-given-name-group" label-for="provider-given-name-input" label="Given name:">
                            <b-form-input id="provider-given-name-input" v-model="form.givenName" type="text" placeholder="Given Name"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="3">
                        <b-form-group id="provider-family-name-group" label-for="provider-family-name-input" label="Family name:">
                            <b-form-input id="provider-family-name-input" v-model="form.familyName" type="text" placeholder="Family Name"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="6">
                        <b-form-group id="provider-country-group" label-for="provider-country-select" label="Country:">
                            <b-form-select id="provider-country-select" v-model="form.selectedCountry" :options="form.countries"></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="6">
                        <b-form-group id="provider-company-group" label-for="provider-company-input" label="Company Name:">
                            <b-form-input id="provider-company-input" v-model="form.companyName" type="text" placeholder="Company"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="6">
                        <b-form-group id="provider-email-group" label-for="provider-email-input" label="Email:">
                            <b-form-input id="provider-email-input" v-model="form.email" type="text" placeholder="Email"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="6">
                        <b-form-group id="provider-phone-group" label-for="provider-phone-input" label="Phone:">
                            <b-form-input id="provider-phone-input" v-model="form.phone" type="text" placeholder="Phone"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="3">
                        <b-form-group id="provider-password-group" label-for="provider-password-input" label="Password:">
                            <b-form-input id="provider-password-input" v-model="form.password" type="password" placeholder="Password"></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="3">
                        <b-form-group id="provider-confirm-password-group" label-for="provider-confirm-password-input" label="Confirm Password:">
                            <b-form-input id="provider-confirm-password-input" type="password" placeholder="Confirm Password"></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row align-h="center">
                    <b-col cols="6">
                        <div class="g-recaptcha" data-sitekey=process.env.RECAPTCHA_SITE_KEY></div>
                        <b-button type="submit" variant="primary">Submit</b-button>
                    </b-col>
                </b-row>
            </b-container>
        </b-form>
        <div class="mt-3">
            <b-container>
                <b-row align-h="center">
                    <b-col cols="6">
                        <div id="provider-recaptcha" class="g-recaptcha" data-sitekey=process.env.RECAPTCHA_SITE_KEY></div>
                    </b-col>
                </b-row>
            </b-container>
        </div>
    </div>
    <div v-else>
        <b-container>
            <b-row align-h="center">
                <b-col cols="6">
                    <p>
                        You're signed up. Please continue to the sign in page.
                    </p>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
    import User from '../../user.js';

    export default
    {
        name:       'Provider-Signup',
        data ()
        {
            return {
                signedUp:   false,
                form: {
                    selectedCountry: null,
                    givenName:       null,
                    familyName:      null,
                    companyName:     null,
                    email:           null,
                    phone:           null,
                    password:        null,
                    countries: [
                        { value: null, text: "Select one",    abbreviation: "" },
                        { value: 0,    text: "United States", abbreviation: "US" },
                        { value: 1,    text: "Canada",        abbreviation: "CA" }
                    ]
                }
            }
        },
        methods: {
            onSubmit
        },
        mounted: onMounted
    }


    ////////////////////////////////////////////////////////////////////////////////
    //
    //
    //
    function onSubmit( event )
    {
        var recaptchaResponse = grecaptcha.getResponse( this.recaptchaID );
        if( recaptchaResponse.length === 0 )
        {
            alert( "Please verify that you're a human" );
            return;
        }

        var _this = this;
        User.signUp(
                {
                    username: _this.form.email,
                    password: _this.form.password
                },
                {
                    recaptchaResponse: recaptchaResponse,
                    userType:          User.UserEnum.PROVIDER,
                    attributes: [
                        {
                            "key":		"given_name",
                            "value":	_this.form.givenName
                        },
                        {
                            "key":		"family_name",
                            "value":	_this.form.familyName
                        },
                        {
                            "key":		"phone_number",
                            "value":	_this.form.phone
                        },
                        {
                            "key":		"email",
                            "value":	_this.form.email
                        }
                    ]
                },
                function ( response )
                {
                    alert( 'Signup provider success.' );
                    _this.signedUp = true;
                },
                function ( error )
                {
                    alert( 'Signup provider failure' );
                    if( typeof( error.response.data.error.code ) != 'undefined' )
                    {
                        switch( error.response.data.error.code )
                        {
                        case "UserNotConfirmedException":
                            break;
                        }
                    }
                    else
                    {
                        alert( 'An error has occurred while attempting to sign up.' );
                    }
                }
            );
    }


    ////////////////////////////////////////////////////////////////////////////////
    //
    //
    //
    function onMounted()
    {
        this.recaptchaID = grecaptcha.render(
                                "provider-recaptcha",
                                {
                                    sitekey:    process.env.RECAPTCHA_SITE_KEY,
                                }
                            );
    }
</script>


// WEBPACK FOOTER //
// src/components/provider/provider-signup.vue